<template>
    <div class="grid justify-items-start md:justify-items-center ml-10 md:ml-0">
        <ComponentTL
        v-for="(parcours, index) in parcours" 
            :key="index" 
            :parcourName="parcours.name"
            :parcourDescription="parcours.description"
            :parcourDate="parcours.date"
            :parcourImage="parcours.img"
        />

    </div>
</template>
<script>

import ComponentTL from './ComponentTL.vue'
;

export default {
  components: {
    ComponentTL
  },
  data() {
    return {
      parcours:[
        { name: 'Master WebSciD', description: 'Master Web et Sciences des données Université du Littoral Cote d\'opale', date: '2022-2024', img: './img/parcour/ulco.webp' },
        { name: 'Licence Informatique', description: 'Licence Informatique Université du Littoral Cote d\'opale', date: '2021-2022', img: './img/parcour/ulco.webp' },
        { name: 'DUT Informatique', description: ' DUT Informatique IUT Calais', date: '2019-2021', img: './img/parcour/iut.jpg' },
        { name: 'BAC ES', description: 'BAC ES Lycée Léonard de Vinci', date: '2019', img: './img/parcour/hqe.jpg'},
      ],
    };
  },
};

</script>
